import { Club, Competition } from '@repo/types';
import { ClubListProps } from './ClubList';
import { ClubCard } from '../ClubCard';

export type ClubListUIProps = Omit<ClubListProps, 'competitionId'> & {
  clubs: Club[];
  competition: Competition;
};

function ClubListUI({ clubs, competition, hideCompetitionName, nameType, columns }: ClubListUIProps) {
  const divisionName = competition.name?.split?.('-')?.[1] ?? '';

  return (
    <section className="league-division-section">
      {!hideCompetitionName && (
        <header className="league-division-section__header">
          <h2 className="league-division-section__name">{divisionName}</h2>
        </header>
      )}
      <div className="league-division-section__body">
        <ul className="league-division-section__club-list" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
          {clubs.map((club) => (
            <li key={club.id} className="league-division-section__club-list-item">
              <ClubCard club={club} nameType={nameType} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default ClubListUI;
